export default { 
    'PPTshare.Title':'The speech is not open for public access',
    'PPTshare.Tips':'If you have access to play the document, please log in and view it',
    'PPTshare.btn':'Start using',
}